export default "__VITE_ASSET__CewSy1yg__"